var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from '@web/components/layout/Form/Input';
import { Select } from '@web/components/ui/Form/Select';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export var MeetingDurationType;
(function (MeetingDurationType) {
    MeetingDurationType["ON_TIME_WITHIN"] = "ON_TIME_WITHIN";
    MeetingDurationType["DURATION_LESS"] = "DURATION_LESS";
    MeetingDurationType["DURATION_MORE"] = "DURATION_MORE";
    MeetingDurationType["OVERRUN_DURATION_MORE"] = "OVERRUN_DURATION_MORE";
    MeetingDurationType["OVERRUN_DURATION_LESS"] = "OVERRUN_DURATION_LESS";
})(MeetingDurationType || (MeetingDurationType = {}));
var MEETING_DURATION_TYPE_OPTIONS = [
    MeetingDurationType.ON_TIME_WITHIN,
    MeetingDurationType.DURATION_LESS,
    MeetingDurationType.DURATION_MORE,
    MeetingDurationType.OVERRUN_DURATION_MORE,
    MeetingDurationType.OVERRUN_DURATION_LESS
];
export function MeetingDurationTypeFilter(_a) {
    var _b;
    var _c = _a.isDisplayLabel, isDisplayLabel = _c === void 0 ? true : _c;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var _d = useFilters(), meetingDurationType = _d.meetingDurationType, durationHours = _d.durationHours, durationMinutes = _d.durationMinutes;
    var totalMinutes = (durationHours || 0) * 60 + (durationMinutes || 0);
    var options = __spreadArray([
        {
            id: null,
            name: t('filters.all'),
            isAll: true
        }
    ], MEETING_DURATION_TYPE_OPTIONS.map(function (type) { return ({
        id: type,
        name: t("filters.meetingDurationType.".concat(type))
    }); }), true);
    var selectedMeetingDurationType = (_b = options.find(function (option) { return option.id === meetingDurationType; })) !== null && _b !== void 0 ? _b : options[0];
    var onChange = function (meetingDurationType) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                meetingDurationType: meetingDurationType.id
            }
        });
    };
    var onChangeDurationMinutes = function (value) {
        var minutes = value === '' ? 0 : parseInt(value, 10);
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                durationHours: 0,
                durationMinutes: Number.isNaN(minutes) ? 0 : minutes
            }
        });
    };
    return (_jsxs("div", __assign({ className: "w-full flex items-center gap-2" }, { children: [_jsx("div", __assign({ className: "min-w-0 flex-1" }, { children: _jsx(Select, { isDisplayLabel: isDisplayLabel, selected: selectedMeetingDurationType, options: options, onChange: onChange, className: "w-full" }) })), _jsx(Input, { className: "w-16 shrink-0", type: "number", value: totalMinutes, onChange: onChangeDurationMinutes, min: 0 }), _jsx("span", __assign({ className: "text-sm text-gray-700 shrink-0" }, { children: t('filters.durationMinutesUnit') }))] })));
}
